import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id EF2E3070-75EC-44C3-9ECE-780BB330D51B
 * name flag-plus
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-plus.svg
 * tags
 */
export const FlagPlusIcon = createSvgIcon(<><path d="M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12.4,5H18V12C15.78,12 13.84,13.21 12.8,15H11L10.6,13H5V20H3V3H12L12.4,5Z" /></>, 'FlagPlusIcon');
export default FlagPlusIcon